<template>
  <div class='procedure-editor'>
    <flash-message></flash-message>
    <div class='procedure__viewer'>
      

      <div class='procedure__content'>


        <article class='procedure__description ck-content' v-if='procedure.description && !showEdit' v-html="procedure.description"></article>

        <div class='procedure__toolbar'>
          <div class='button-group' v-if='can'>

            <template v-if='!showEdit'>
              <a href='#' @click.prevent.stop='toggleEdit' class='button button--secondary'><i class='fas fa-edit'></i>Edit</a>
              <template v-if='!turn_off_completion'>
                <a href='#' v-if='procedure.completed > 0' class='button button--secondary' @click.prevent.stop='copyCompletedTasks'><i class='fas fa-copy'></i>Copy Completed Tasks ({{procedure.completed}})</a>
                <slot></slot>
              </template>
            </template>

            
            <template v-if='showEdit'>
              <a href='#' @click.prevent.stop='toggleEdit' class='button button--secondary'><i class='fas fa-times'></i>Cancel</a>
              <a href='#' @click.prevent.stop="addTask" class='button button--success'><i class='fas fa-plus'></i>New Task</a>
              <a href='#' v-if='tasksLength == 0' @click.prevent.stop='toggleBulk' class='button button--success'><i class="fas fa-plus-circle"></i>Bulk Add</a>
              <a href='#' v-if='tasksLength > 0' @click.prevent.stop='toggleSort' class='button button--secondary'><i class="fas fa-cog"></i>Edit structure</a>
              <a href='#' @click.prevent.stop='submitForm' class='button button--primary'><i class="fas fa-save"></i>Update</a>
            </template>
          </div>
          <div v-if='!can'></div>
          <div v-if='!turn_off_completion'>
            <div class='procedure__fraction--main procedure__fraction ' v-if='(procedure.completed != procedure.total) || procedure.total == 0'>
              <span class='procedure__completed'>{{procedure.completed}}</span><span>/</span><span class='procedure__total'>{{procedure.total}}</span> completed<div class='success-percent' :style='{width: procedure.completion_percentage}'></div></div>
              <div class='procedure__fraction procedure__fraction--main procedure__fraction success' v-if='(procedure.completed == procedure.total) && procedure.total != 0'>
                <span class='procedure__total'>Complete!</span><div class='success-percent' :style='{width: procedure.completion_percentage}'>
              </div>
            </div>
          </div>
        </div>

        <div v-if='showBulk' class='procedure__bulk'>
          <textarea v-model='bulk' placeholder='Add each task on a separate line...'></textarea>
          <a href='#' class='button button--primary' @click.prevent.stop='convertBulk'>Convert to Tasks</a>
        </div>

        <div class='procedure__form' v-if='showEdit'>
          <div class='task-sorter' v-if='showSort'>
            <div style='display: inline-block;'>
              <a href='#' @click.prevent.stop='toggleSort' class='button button--secondary'><i class='fas fa-times'></i>Close</a>
            </div>
            <p>Drag and drop tasks to rearrange...</p>
            <draggable v-model="procedure_tasks_attributes" @end="onSortEnd">
              <transition-group>

                <div class='task-sorter__task' v-show='!task._destroy' :key="'drag' + index" v-for='(task, index) in procedure_tasks_attributes'>
                  <h1><i class='fas fa-bars'></i> {{task.name}}</h1>
                  <a @click.prevent.stop='removeTask(index, task.id)' href='#' class='button button--danger button--small'><i class="fas fa-trash"></i>Delete Task</a>
                </div>
              </transition-group>
            </draggable>
          </div>
          <form class='form' v-if='!showSort' @submit.prevent.stop="submitForm">
            <div class='form-group'>
              <label for='procedure_name' class='required'>Name</label>
              <input type='text' required id='procedure_name' v-model='name'>
            </div>

            <div class='form-group'>
              <label for='procedure_description'>Description</label>

              <writer :record_id='id' record_type='Procedure'></writer>
            </div>

            <div class='procedure-editor__procedure' v-show='!task._destroy' v-for='(task, index) in procedure_tasks_attributes'>
              <div class='procedure-editor__box'>
                <div class='form-group'>
                  <label class='required' :for='"task" + index' placeholder=''>Task Name</label>
                  <input type='text' :id='"task" + index' required :value='task.name' @input='e => updateTaskName(index, e)'>
                </div>
                <div class='form-group'>
                  <label>Notes</label>

                  <writer :record_id='id' record_type='Procedure' :description="task.description" :index='index'></writer>
                  
                </div>
              </div>
            </div>
            
          </form>
        </div>
        <div v-if='!showEdit'>
          <div v-show='procedure.procedure_tasks_attributes.length > 0'>
            <div :class='{"procedure": true, "procedure--full": turn_off_completion, "procedure--completed": turn_off_completion}' v-for='(task, index) in procedure.procedure_tasks_attributes'>
              <aside v-if='!turn_off_completion'>
                <input type='checkbox' v-if='can' :checked='task.completed' @input="check(task.id, index, task.completed)">
                
              </aside>
              <main>
                <h1 class='procedure__title'>{{task.name}}</h1>
                <div v-html="task.description" v-if='task.description' class='ck-content'></div>
              </main>
              <div v-show='task.completed && !turn_off_completion' class='procedure__complete'>Completed on {{task.completed_date}} by {{task.user_name}}
              </div>
            </div>
          </div>
          <div class='procedure__blank' v-show='procedure.procedure_tasks_attributes.length == 0 && !showBulk'>Are you procrastinating? Add some tasks, and get stuff done.</div>
        </div>
      </div>
    </div>
   
  </div>
</template>

<script>
const axios = require('axios');
import draggable from 'vuedraggable'
import Writer from './process_writer.vue';
import { mapState, mapGetters } from 'vuex'

export default {
  props: ["url", "can", "turn_off_completion", "id"],
  components: {
    draggable,
    Writer
  },
  computed: {
    ...mapState("procedures", {
      'showEdit':  'showEdit',
      'showBulk': 'showBulk',
      'showSort': 'showSort',
      'procedure': 'procedure'
    }),
     ...mapGetters("procedures", {
      'tasksLength':  'tasksLength'
    }),
    name: {
      get() {
        return this.$store.state.procedures.procedure.name
      },
      set(value) {
        this.$store.dispatch('procedures/updateProcedureName', value)
      }
    }, 
    description: {
      get() {
        return this.$store.state.procedures.procedure.description
      },
      set(value) {
        this.$store.dispatch('procedures/updateProcedureDescription', value)
      }
    },
    bulk: {
      get() {
        return this.$store.state.procedures.bulk
      },
      set(value) {
        this.$store.dispatch('procedures/updateBulk', value)
      }
    },
    procedure_tasks_attributes: {
      get() {
        return this.procedure.procedure_tasks_attributes
      },
      set(value) {
        this.$store.dispatch('procedures/update_tasks', value)
      }
    }
  },
  mounted () {
    this.$store.dispatch('procedures/setState', [this.url, this.can, this.template])
    this.$store.dispatch('procedures/fetch');
  },
  methods: {
    updateTaskName(index, e) {
      this.$store.dispatch('procedures/updateTaskName', [index, e.target.value]);
    },
    convertBulk() {
      this.$store.dispatch('procedures/convertBulk');
    },
    onSortEnd () {
      this.$store.dispatch('procedures/resort');
    },
    toggleEdit () {
      this.$store.dispatch('procedures/toggleEdit');
    },
    toggleBulk () {
      this.$store.dispatch('procedures/toggleBulk');
    },
    toggleSort () {
      this.$store.dispatch('procedures/toggleSort');
    },
    check (id, index, completed) {
      this.$store.dispatch('procedures/check', [id, index, completed]);
    },
    addTask () {
      this.$store.dispatch('procedures/addTask');
    },
    removeTask (index, id) {
      this.$store.dispatch('procedures/removeTask', [index, id]);
    },
    copyCompletedTasks () {

      if (this.procedure.completed == 0) {
        return alert("Complete tasks first!")
      }
      var that = this;
      var text = "";
      that.procedure.procedure_tasks_attributes.forEach ( function (item, idx) {
        if (item.completed ) {
          text += "✔ COMPLETED - " + item.name; 
          if (idx != that.procedure.procedure_tasks_attributes.length - 1) {
            text += "\n";
          }
        }
      })
      Clipboard.copy(text);

      that.flash("Copied!", 'success', 
        {
          timeout: 3000,
          important: true
        }
      );
      text = "";
    },
    submitForm () {
      this.$store.dispatch('procedures/submitForm');
    }
  }
}

window.Clipboard = (function(window, document, navigator) {
    var textArea,
        copy;

    function isOS() {
        return navigator.userAgent.match(/ipad|iphone/i);
    }

    function createTextArea(text) {
        textArea = document.createElement('textArea');
        textArea.value = text;
        document.body.appendChild(textArea);
    }

    function selectText() {
        var range,
            selection;

        if (isOS()) {
            range = document.createRange();
            range.selectNodeContents(textArea);
            selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            textArea.setSelectionRange(0, 999999);
        } else {
            textArea.select();
        }
    }

    function copyToClipboard() {        
        document.execCommand('copy');
        document.body.removeChild(textArea);
    }

    copy = function(text) {
        createTextArea(text);
        selectText();
        copyToClipboard();
    };

    return {
        copy: copy
    };
})(window, document, navigator);
</script>

